export default __webpack_public_path__ + "static/connect-wallet-illustration-dark-3b5c6866d307ed06e8e9a4f8d76215af.svg";